// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

export const getCompany = createAsyncThunk('appCompany/getCompany', async () => {
   const response = await axios.get(apiLink('getCompany'))
   return response.data
})

export const updateCompany = createAsyncThunk('appCompany/updateCompany', async data => {
   const response = await axios.put(apiLink('updateCompany'), data)
   return response.data
})

export const getCurrentSubscription = createAsyncThunk('appCompany/getCurrentSubscription', async () => {
   const response = await axios.get(apiLink('getCurrentSubscription'))
   return response.data
})

export const getSubscriptionPlans = createAsyncThunk('appCompany/getSubscriptionPlans', async () => {
   const response = await axios.get(apiLink('getSubscriptionPlans'))
   return response.data
})

export const requestSubscriptionChange = createAsyncThunk('appCompany/requestSubscriptionChange', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/subscriptions/request?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

export const getPermissions = createAsyncThunk('appCompany/getPermissions', async () => {
   const response = await axios.get(apiLink('getPermissions'))
   return response.data
})
export const getWarehouses = createAsyncThunk('appCompany/getWarehouses', async () => {
   const response = await axios.post(apiLink('getWarehouses'), { page: 0, rows: 100 })
   return response.data.content
})
export const getStations = createAsyncThunk('appCompany/getStations', async () => {
   const response = await axios.post(apiLink('getStations'), { page: 0, rows: 100 })
   return response.data.content
})

export const addPermission = createAsyncThunk('appCompany/addPermission', async data => {
   delete data.id
   const response = await axios.post(apiLink('addPermission'), data)
   return response.data
})

export const updatePermission = createAsyncThunk('appCompany/updatePermission', async data => {
   const response = await axios.put(apiLink({name: 'updatePermission', value: data.id}), data)
   return response.data
})

export const removePermission = createAsyncThunk('appCompany/removePermission', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePermission', value: id}))
   return response.data
})

export const getUsers = createAsyncThunk('appCompany/getUsers', async (params) => {
   const response = await axios.get(apiLink('getUsers', params))
   return {
      params,
      data: response.data.users,
      totalPages: response.data.total_elements
   }
})

export const addUser = createAsyncThunk('appCompany/addUser', async (data) => {
   const response = await axios.post(apiLink('addUser'), data)
   return response.data
})
export const getUser = createAsyncThunk('appCompany/getUser', async (user_id) => {
   const response = await axios.get(apiLink({name: 'getUser', value: user_id}))
   return response.data
})
export const updateUser = createAsyncThunk('appCompany/updateUser', async data => {
   const user_id = data.id
   delete data.id
   const response = await axios.put(apiLink({name: 'updateUser', value: user_id}), data)
   return response.data
})

export const deactivateUser = createAsyncThunk('appCompany/deactivateUser', async (id) => {
   const response = await axios.delete(apiLink({name: 'deactivateUser', value: id}))
   return response.data
})

// ** Profile actions
export const getProfile = createAsyncThunk('appCompany/getProfile', async () => {
   const response = await axios.get(apiLink('getProfile'))
   return response.data
})
export const updateProfile = createAsyncThunk('appCompany/updateProfile', async data => {
  const response = await axios.put(apiLink('updateProfile'), data)
  return response.data
})

export const getPricing = createAsyncThunk('appCompany/getPricing', async () => {
   const response = await axios.get('/api/company/pricing')
   return response.data
})

// ** Actions
export const getUserActions = createAsyncThunk('appCompany/getUserActions', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   if (!params.user_id) {
      delete params.user_id
   }
   const response = await axios.get(apiLink('getUserActions', params))   
   return {
      actions: response.data.actions,
      actions_params: params,
      actions_total: response.data.total_elements
   }
})
export const getUserActionsEventLink = createAsyncThunk('appCompany/getUserActionsEventLink', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/actions/link?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getRentLinkByPeriodId = createAsyncThunk('appCompany/getRentLinkByPeriodId', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/actions/rent-link-period?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getCreditLinkByPeriodId = createAsyncThunk('appCompany/getCreditLinkByPeriodId', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/actions/credit-link-period?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// Reports 
export const getCompanyReport = createAsyncThunk('appCompany/getCompanyReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/report/company?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getCompanyPeriodReport = createAsyncThunk('appCompany/getCompanyPeriodReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/report/company/period?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getCompanyPredictionReport = createAsyncThunk('appCompany/getCompanyPredictionReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/report/company/prediction?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Monobank
export const getMonobankSettings = createAsyncThunk('appCompany/getMonobankSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMonobankAllSettings = createAsyncThunk('appCompany/getMonobankAllSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank/all?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const addMonobankConnection = createAsyncThunk('appCompany/addMonobankConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank/add?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateMonobankConnection = createAsyncThunk('appCompany/updateMonobankConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const removeMonobankConnection = createAsyncThunk('appCompany/removeMonobankConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank/remove?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMonobankAccounts = createAsyncThunk('appCompany/getMonobankAccounts', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank/accounts/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateMonobankAccounts = createAsyncThunk('appCompany/updateMonobankAccounts', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank/accounts/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMonobankData = createAsyncThunk('appCompany/getMonobankData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank/data/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMonobankReport = createAsyncThunk('appCompany/getMonobankReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/monobank/data/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Privatbank
export const getPrivatbankSettings = createAsyncThunk('appCompany/getPrivatbankSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getPrivatbankAllSettings = createAsyncThunk('appCompany/getPrivatbankAllSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank/all?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const addPrivatbankConnection = createAsyncThunk('appCompany/addPrivatbankConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank/add?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updatePrivatbankConnection = createAsyncThunk('appCompany/updatePrivatbankConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const removePrivatbankConnection = createAsyncThunk('appCompany/removePrivatbankConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank/remove?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getPrivatbankAccounts = createAsyncThunk('appCompany/getPrivatbankAccounts', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank/accounts/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updatePrivatbankAccounts = createAsyncThunk('appCompany/updatePrivatbankAccounts', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank/accounts/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getPrivatbankData = createAsyncThunk('appCompany/getPrivatbankData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank/data/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getPrivatbankReport = createAsyncThunk('appCompany/getPrivatbankReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/privatbank/data/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})


// ** Integrations
export const getGPSOnlineSettings = createAsyncThunk('appCompany/getGPSOnlineSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const addGPSOnlineConnection = createAsyncThunk('appCompany/addGPSOnlineConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/add?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateGPSOnlineConnection = createAsyncThunk('appCompany/updateGPSOnlineConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getGPSOnlineDevices = createAsyncThunk('appCompany/getGPSOnlineDevices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateGPSOnlineDevices = createAsyncThunk('appCompany/updateGPSOnlineDevices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getTrackingDeviceData = createAsyncThunk('appCompany/getTrackingDeviceData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getGPSOnlineReport = createAsyncThunk('appCompany/getGPSOnlineReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getIntegrationServices = createAsyncThunk('appCompany/getIntegrationServices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Wialon
export const getWialonSettings = createAsyncThunk('appCompany/getWialonSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const addWialonConnection = createAsyncThunk('appCompany/addWialonConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/add?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateWialonConnection = createAsyncThunk('appCompany/updateWialonConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getWialonDevices = createAsyncThunk('appCompany/getWialonDevices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateWialonDevices = createAsyncThunk('appCompany/updateWialonDevices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getWialonDeviceData = createAsyncThunk('appCompany/getWialonDeviceData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getWialonReport = createAsyncThunk('appCompany/getWialonReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** UniTalk
export const getUnitalkSettings = createAsyncThunk('appCompany/getUnitalkSettings', async () => {
   const response = await axios.post(`https://api.mfauto.com.ua/unitalk/settings/get?env=${process.env.REACT_APP_NODE_ENV}`, {
      token: localStorage.getItem('token')
   })
   return response.data
})
export const saveUnitalkSettings = createAsyncThunk('appCompany/saveUnitalkSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/unitalk/settings/save?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const getUnitalkCallsList = createAsyncThunk('appCompany/getUnitalkCallsList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/unitalk/calls/list?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...params,
      token: localStorage.getItem('token')
   })
   return {
      params,
      data: response.data.calls,
      totalPages: response.data.total_elements
   }
})

// ** Mapon
export const getMaponSettings = createAsyncThunk('appCompany/getMaponSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const addMaponConnection = createAsyncThunk('appCompany/addMaponConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/add?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateMaponConnection = createAsyncThunk('appCompany/updateMaponConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMaponDevices = createAsyncThunk('appCompany/getMaponDevices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateMaponDevices = createAsyncThunk('appCompany/updateMaponDevices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMaponDeviceData = createAsyncThunk('appCompany/getMaponDeviceData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMaponReport = createAsyncThunk('appCompany/getMaponReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Mega GPS
export const getMEGAGPSSettings = createAsyncThunk('appCompany/getMEGAGPSSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const addMEGAGPSConnection = createAsyncThunk('appCompany/addMEGAGPSConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/add?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateMEGAGPSConnection = createAsyncThunk('appCompany/updateMEGAGPSConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMEGAGPSDevices = createAsyncThunk('appCompany/getMEGAGPSDevices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateMEGAGPSDevices = createAsyncThunk('appCompany/updateMEGAGPSDevices', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getMEGAGPSReport = createAsyncThunk('appCompany/getMEGAGPSReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/tracking/devices/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Navigator
export const getNavigatorSettings = createAsyncThunk('appCompany/getNavigatorSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/navigator?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const removeNavigatorConnection = createAsyncThunk('appCompany/removeNavigatorConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/navigator/remove?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getNavigatorVehicles = createAsyncThunk('appCompany/getNavigatorVehicles', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/navigator/vehicles/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateNavigatorVehicles = createAsyncThunk('appCompany/updateNavigatorVehicles', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/navigator/vehicles/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getNavigatorData = createAsyncThunk('appCompany/getNavigatorData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/navigator/data/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getNavigatorReport = createAsyncThunk('appCompany/getNavigatorReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/navigator/data/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Bolt
export const getBoltSettings = createAsyncThunk('appCompany/getBoltSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getBoltAllSettings = createAsyncThunk('appCompany/getBoltAllSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt/all?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const addBoltConnection = createAsyncThunk('appCompany/addBoltConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt/add?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateBoltConnection = createAsyncThunk('appCompany/updateBoltConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const removeBoltConnection = createAsyncThunk('appCompany/removeBoltConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt/remove?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getBoltVehicles = createAsyncThunk('appCompany/getBoltVehicles', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt/vehicles/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateBoltVehicles = createAsyncThunk('appCompany/updateBoltVehicles', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt/vehicles/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getBoltData = createAsyncThunk('appCompany/getBoltData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt/data/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getBoltReport = createAsyncThunk('appCompany/getBoltReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/bolt/data/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Uklon
export const getUklonSettings = createAsyncThunk('appCompany/getUklonSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getUklonAllSettings = createAsyncThunk('appCompany/getUklonAllSettings', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/all?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const addUklonConnection = createAsyncThunk('appCompany/addUklonConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/add?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateUklonConnection = createAsyncThunk('appCompany/updateUklonConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const removeUklonConnection = createAsyncThunk('appCompany/removeUklonConnection', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/remove?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getUklonVehicles = createAsyncThunk('appCompany/getUklonVehicles', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/vehicles/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateUklonVehicles = createAsyncThunk('appCompany/updateUklonVehicles', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/vehicles/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getUklonDrivers = createAsyncThunk('appCompany/getUklonDrivers', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/drivers/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateUklonDrivers = createAsyncThunk('appCompany/updateUklonDrivers', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/drivers/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getUklonData = createAsyncThunk('appCompany/getUklonData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/data/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getUklonCustomersData = createAsyncThunk('appCompany/getUklonCustomersData', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/data/customers?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getUklonReport = createAsyncThunk('appCompany/getUklonReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/data/report?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getUklonVehicleReport = createAsyncThunk('appCompany/getUklonVehicleReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/data/report/vehicle?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getUklonPeriodCustomerReport = createAsyncThunk('appCompany/getUklonPeriodCustomerReport', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/integrations/uklon/data/report-customer?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Extra reports
export const XtraYearly = createAsyncThunk('appCompany/XtraYearly', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/report/xtra-yearly?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** currency exchange history
export const getCurrencyHistoryList = createAsyncThunk('appCompany/getCurrencyHistoryList', async (params) => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/exchange-rate/history?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...params,
      token: localStorage.getItem('token')
   })

   return {
      params,
      data: response.data.history,
      totalPages: response.data.total_elements
   }   
})

export const getBillingDetails = createAsyncThunk('appCompany/getBillingDetails', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/billing-details/list?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const addBillingDetail = createAsyncThunk('appCompany/addBillingDetail', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/billing-details/add?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const updateBillingDetail = createAsyncThunk('appCompany/updateBillingDetail', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/billing-details/edit?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})
export const removeBillingDetail = createAsyncThunk('appCompany/removeBillingDetail', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/billing-details/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

// ** External fields
export const getExternalFields = createAsyncThunk('appCompany/getExternalFields', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/external-fields/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateExternalFields = createAsyncThunk('appCompany/updateExternalFields', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/external-fields/update?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const removeExternalField = createAsyncThunk('appCompany/removeExternalFields', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/external-fields/remove?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getExternalFieldsBatch = createAsyncThunk('appCompany/getExternalFieldsBatch', async (data, { signal }) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/external-fields/get-batch?env=${process.env.REACT_APP_NODE_ENV}`, data, { signal })
   if (response.data?.error) {
      throw new Error(response.data.error.message)
   }
   return {
      fields: response.data?.fields ?? [],
      values: response.data?.values ?? {},
      car_info: response.data?.car_info ?? {}
   }
})

// ** Company balance
export const getCompanyBalance = createAsyncThunk('appCompany/getCompanyBalance', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/kyc/balance?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getCompanyProducts = createAsyncThunk('appCompany/getCompanyProducts', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/kyc/products?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const createPortmonePayment = createAsyncThunk('appCompany/createPortmonePayment', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/kyc/payment?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getCompanyPayments = createAsyncThunk('appCompany/getCompanyPayments', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/company/kyc/orders?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Person checks
// ** Backend error body -> Error with backend message (sources with per-registry codes go to the console)
const personCheckRequest = async (path, data) => {
   const toError = (body) => {
      const message = typeof body.error === 'string' ? body.error : body.error?.message
      const sources = body.error?.sources || body.sources

      if (sources !== undefined) {
         console.warn('person-check sources', sources)
      }

      return new Error(message || 'Person check error')
   }

   try {
      const response = await axios.post(`https://api.mfauto.com.ua/company/kyc/${path}?env=${process.env.REACT_APP_NODE_ENV}`, data)

      if (response.data?.error) {
         throw toError(response.data)
      }

      return response.data
   } catch (error) {
      if (error.response?.data?.error) {
         throw toError(error.response.data)
      }

      throw error
   }
}

export const checkPerson = createAsyncThunk('appCompany/checkPerson', async (data) => personCheckRequest('person-check', data))
export const getPersonCheckReport = createAsyncThunk('appCompany/getPersonCheckReport', async (data) => personCheckRequest('person-check/stored', data))

export const appUsersSlice = createSlice({
   name: 'appCompany',
   initialState: {
      profile: [],
      company: [],
      users: [],
      permissions: [],
      warehouses: [],
      stations: [],
      actions: [],
      actions_params: {},
      actions_total: 0,
      integrations: [],
      currencyHistory: [],
      total: 1,
      params: {}
   },
   reducers: {},
   extraReducers: builder => {
      builder
      .addCase(getProfile.fulfilled, (state, action) => {
         const role_name = action.payload.role.name
         state.profile = action.payload
         state.profile.role = role_name
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
         const role_name = action.payload.role.name,
               ability   = action.payload.role.permissions.map((item) => ({subject: item, action: 'read'}))

         state.profile = action.payload
         state.profile.role = role_name
         state.profile.ability = ability

         localStorage.setItem('userData', JSON.stringify(state.profile))
      })
      .addCase(getCompany.fulfilled, (state, action) => {
         state.company = action.payload
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
         state.company = action.payload
      })
      .addCase(getUsers.fulfilled, (state, action) => {
         state.users = action.payload.data
      })
      .addCase(updateUser.fulfilled, (state, action)  => {
         const index = state.users.findIndex(obj => obj.id === action.payload.id)
         state.users[index] = action.payload
      })
      .addCase(getPermissions.fulfilled, (state, action) => {
         state.permissions = action.payload
      })
      .addCase(getWarehouses.fulfilled, (state, action) => {
         state.warehouses = action.payload
      })
      .addCase(getStations.fulfilled, (state, action) => {
         state.stations = action.payload
      })
      .addCase(addPermission.fulfilled, (state, action) => {
         state.permissions = [...state.permissions, action.payload]
      })
      .addCase(updatePermission.fulfilled, (state, action) => {
         const index = state.permissions.findIndex(obj => obj.id === action.payload.id)
         state.permissions[index] = action.payload
      })
      .addCase(removePermission.fulfilled, (state, action) => {
         const index = state.permissions.findIndex(obj => obj.id === action.meta.arg)
         state.permissions = [
            ...state.permissions.slice(0, index),
            ...state.permissions.slice(index + 1)
         ]
      })
      .addCase(getUserActions.fulfilled, (state, action) => {
         state.actions = action.payload.actions
         state.actions_params = action.payload.actions_params
         state.actions_total = action.payload.actions_total
      })
      .addCase(getCurrencyHistoryList.fulfilled, (state, action) => {
         state.currencyHistory = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
   }
})

export default appUsersSlice.reducer
